// removed by extract-text-webpack-plugin
module.exports = {"baseInfo":"baseInfo_baseInfo_1aM5_","pic":"baseInfo_pic_3uV-w","info":"baseInfo_info_2Nb5g","btns":"baseInfo_btns_2qWHw","reportInfo":"baseInfo_reportInfo_3kniI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/company/overviewModal/baseInfo.scss
// module id = 1560
// module chunks = 0